import React from "react";
import { Tooltip as AntTooltip } from "antd";
import { TooltipProps as AntTooltipProps } from "antd/lib/tooltip";

export const Tooltip = (props: AntTooltipProps) => {
  const { children, ...rest } = props;

  return <AntTooltip {...rest}>{children}</AntTooltip>;
};
